export default "__VITE_ASSET__2KME9D$M__"